import { render, staticRenderFns } from "./Cabecalho.vue?vue&type=template&id=51a07112&scoped=true"
import script from "./Cabecalho.vue?vue&type=script&lang=ts"
export * from "./Cabecalho.vue?vue&type=script&lang=ts"
import style0 from "./Cabecalho.vue?vue&type=style&index=0&id=51a07112&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51a07112",
  null
  
)

export default component.exports